import { mapState } from 'vuex'
import { nicTypeOf } from '@/untils/untils'
export default {
  computed: {
    ...mapState({
      outputParams: s => s.outputParams
    })
  },
  mounted() {
    // this.renderData()
  },

  methods: {
    renderData() {
      console.log(22);
      let o = this.outputParams[this.type]
      console.log(o);
      let i = 0
      Object.keys(o).map(key => {
        let val = o[key]
        if (nicTypeOf(val, 'Object')) {
          let t = this.paramsList[i++]
          console.log(i);
          t.list.map(t => {

            t.vModel = +val[t.prop].toFixed(2)

          })
        }

        // 冷冻机ByPassFlow - 特殊处理
        if (key == 'Bypass_Flow') this.paramsList[3].list[0].vModel = val
      })
    },
  },
}